import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { useParams } from 'react-router';
import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ResponsiveLayout from '../../../Layouts/ResponsiveLayout';
import { StateContext, DispatchContext } from '../../../../context/Provider';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';
import {
    Box, Button, Divider, Grid,
    IconButton, Paper, 
    Tooltip, Typography 
} from '@material-ui/core';

import ClassworkSubmissions from './ClassworkSubmissions/ClassworkSubmissions';

const useStyles = makeStyles((theme) => ({
    margin: {
        marginTop: 5
    },
    heading: {
        fontSize: '0.875rem',
        fontWeight: 500
    },
    truncate: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
}));

const ViewClasswork = (props) => {

    const { classcode, classwork_id } = useParams();
    const classes = useStyles();

    const appDispatch = useContext(DispatchContext);
    const { globalDispatch } = appDispatch;

    const [classwork, setClasswork] = useState({});
    const [submissions, setSubmissions] = useState([]);
    const [studentID, setStudentID] = useState(null);
    const [submissionCommentCount, setSubmissionCommentCount] = useState(0);

    async function fetchClassworkSubmissions() {

        try {

            const response = await axiosConfig.get(`/viewClasswork/${classwork_id}`); 
            const { data } = response.data;

            console.log(data);

            setClasswork(data.classwork);
            setSubmissions(data.submissions);
            setSubmissionCommentCount(data.submissionCommentCount);
            setStudentID(data.studentID);
            
        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    useEffect(() => {

        console.log('viewClasswork component mounted');

        if (!classcode || !classwork_id) {
            <Redirect to="/dashboard" />;
        }

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setTabValue', value: 1});
        globalDispatch({type: 'setShowTabs', value: true});

        const source = axiosConfig.CancelToken.source();
        fetchClassworkSubmissions();

        return () => {
            source.cancel();
        }

    }, []);

    if (typeof classwork == 'undefined') {
        return <Redirect to="/dashboard" />;
    }

    return (
        <ResponsiveLayout classcode={classcode}>

            <Box mt={2} />

            { classwork.title ? (
                <Grid 
                    container 
                    spacing={2}
                    justify="center"
                >
                    <Grid item xl={6} lg={6} md={8} sm={12} xs={12}>
                        <Paper elevation={1}>
                            <Box p={2}>
                                <Box pb={1}>
                                    <Grid container justify="space-between">
                                        <Grid item lg={11} xs={11}>
                                            <Box pt={1}>
                                                <Typography variant="h5" color="primary">
                                                    {classwork.title}
                                                </Typography>
    
                                                <Box pt={1}>
                                                    <Typography variant="body1" color="textSecondary">
                                                        {`${classwork.posted_by} - ${classwork.formatted_created_at}`}
                                                    </Typography>
    
                                                    <Typography variant="body1" style={{fontWeight: 500}}>
                                                        {classwork.total_pts || 0} points
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item lg={1} xs={1} style={{textAlign: 'right'}}>
                                            <IconButton
                                                aria-label="edit"
                                                onClick={() => console.log('clicked')}>
                                                <Tooltip title="Select Option">
                                                    <MoreVertIcon />
                                                </Tooltip>
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Box>
    
                                <Divider />
    
                                <Box pt={2}>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {classwork.description}
                                    </Typography>
                                </Box>
    
                                <Box pt={5}>
                                    <Typography variant="body2" color="textPrimary" component="p">
                                        Attachment/s:
                                    </Typography>

                                    { classwork.attachments ? (
                                        <Box style={{marginLeft: -5}}>
                                            <Button
                                                size="small" 
                                                color="primary" 
                                                // href="http://www.africau.edu/images/default/sample.pdf"
                                                href={classwork.attachments_url || ''}
                                                target="_blank"
                                                download
                                            >
                                                { classwork.attachments || ''}
                                            </Button>
                                        </Box>) : null 
                                    }

                                    {classwork.files && classwork.files.map((file, i) => (
                                        <Box style={{marginLeft: -5}} key={i}>
                                            <Button
                                                size="small" 
                                                color="primary" 
                                                href={file.file_url || ''}
                                                target="_blank"
                                                download
                                            >
                                                { file.file_name || ''}
                                            </Button>
                                        </Box>
                                    ))}

                                    { !classwork.attachments && !classwork.files ? (
                                        'No attachment/s available'
                                    ) : ''}
                                    
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
    
                    <Grid item xl={3} lg={3} md={4} sm={12} xs={12}>
                        <ClassworkSubmissions 
                            classes={classes}
                            fetchClassworkSubmissions={fetchClassworkSubmissions}
                            submissions={submissions}
                            classworkID={classwork_id}
                            submissionCommentCount={submissionCommentCount}
                            studentID={studentID}
                        />
                    </Grid>
                </Grid> ) : null
            }

        </ResponsiveLayout>
    );
}

export default ViewClasswork;